/* eslint-disable formatjs/no-literal-string-in-jsx */
import { FormattedMessage } from "react-intl";
import { Spacer } from "~/components/Spacer";
import { Text } from "~/components/Text";
import { View } from "~/components/View";

// For now we are just hardcoding the text here, but in the future the plan is to
// get this text from onetrust or some other source.
export const GeneralTermsAndConditionsPdf = () => {
  return (
    <View paddingHorizontalLarge>
      <Text colorTheme sizeLarge>
        BAKGRUND
      </Text>
      <Spacer />
      <Text>
        Evidensia kommer att utföra undersökningar och behandlingar i enlighet
        med gällande lagar och regler och vara noggranna och omsorgsfulla vid
        utfärdande av intyg om djurs hälsotillstånd eller vård. Sjukvårdande
        behandlingar kan alltid innebära risker för djuret och det kan uppstå
        oförutsedda komplikationer.
      </Text>
      <Spacer />

      <Text>
        I första hand är djurägaren betalningsansvarig för den Sjukvårdande
        behandlingen. För det fall djurägaren inte är betalningsansvarig åtar
        sig undertecknad att tillse att betalning sker enligt punkt 2 i
        Evidensias Allmänna Villkor. Du som skriver in djuret för behandling hos
        Evidensia måste kunna uppvisa giltig legitimation (oavsett om du är
        djurägare eller ombud).
      </Text>
      <Spacer />

      <Text>
        Evidensia behandlar personuppgifter i enlighet med GDPR och följer
        Jordbruksverkets föreskrifter. Som kund hos oss godkänner du att
        provmaterial med tillhörande personuppgifter får delas till
        underleverantörer såsom laboratorier och andra diagnostiktjänsteföretag.
      </Text>
      <Spacer />

      <Text>
        Den information som finns i journalerna samt kopior på journalerna kan
        lämnas:
      </Text>
      <Spacer />
      <Text>
        - till andra kliniker/djursjukhus i samband med att djuret remitteras
        eller behandlas på annan klinik.
      </Text>
      <Spacer />
      <Text>
        - till försäkringsbolag i samband med kostnadsreglering eller förfrågan
        inför försäkring
      </Text>
      <Spacer />
      <Text>
        - till djurets ägare, för det fall att du inte äger djuret själv, eller
        äger tillsammans med andra personer, samt
      </Text>
      <Spacer />
      <Text>
        - till Jordbruksverket eller andra myndigheter om felaktigheter eller
        brister upptäcks i djurets identitetshandlingar eller annan
        dokumentation kopplad till djuret.
      </Text>
      <Spacer />
      <Text>
        Provmaterial och relevant journaldata kan även komma att användas
        anonymiserat i forskningssammanhang. För mer information, se Evidensias
        integritetspolicy.
      </Text>
      <Spacer />
      <Text sizeLarge colorTheme>
        ALLMÄNNA VILLKOR FÖR VETERINÄRTJÄNSTER UTFÖRDA AV EVIDENSIA
      </Text>
      <Spacer />
      <Text>
        Dessa Allmänna villkor gäller för Sjukvårdande behandling som Evidensia
        utför på Djurägarens djur. Allmänna villkor är bindande och gäller
        mellan parterna. Det är viktigt att du noga läser igenom och godkänner
        dessa Allmänna villkor innan besöket.
      </Text>
      <Spacer />

      <Text colorTheme sizeLarge>
        SJUKVÅRDANDE BEHANDLING
      </Text>
      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Allmänt</b>: Evidensia ska i den mån det är möjligt anteckna omfattningen av
        den Sjukvårdande behandlingen i journalen. Om Evidensia upptäcker efter
        Inskrivningen att det krävs någon annan omfattning av den Sjukvårdande
        behandlingen ska detta antecknas i journalen och Djurägaren ska så snart
        det kan ske informeras om detta. Vid akut eller livshotande tillstånd
        hos djuret behöver omfattningen av den Sjukvårdande behandlingen inte
        antecknas i journalen förrän efter att den Sjukvårdande behandlingen
        utförts. Evidensia har alltid rätt att, helt eller delvis och utan
        motivering, avböja att utföra Sjukvårdande behandling.`}
          id="4QxoQn"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Besiktning</b>: Om den Sjukvårdande behandlingen utgörs av besiktning av
        djurets status, hälsa eller därmed jämförbart tillstånd ska Evidensia i
        samband med Inskrivningen anteckna syftet med besiktningen. Syftet
        kommer vara avgörande för nivån och omfattningen av besiktningen.
        Djurägaren är medveten om att en besiktning alltid utgör en
        ögonblicksbedömning och en subjektiv värdering.`}
          id="eYsKny"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text colorTheme sizeLarge>
        KOSTNADER, BETALNINGSVILLKOR M.M.
      </Text>
      <Spacer />

      <Text>
        Djurägaren har rätt att få ett Kostnadsförslag från Evidensia för
        kostnaden för den Sjukvårdande behandlingen. Avsevärda förändringar i
        Kostnadsförslaget ska meddelas Djurägaren så snart som möjligt.
        Djurägaren har rätt att sätta ett Kostnadstak för den Sjukvårdande
        behandlingen. Kostnadstaket får inte överskridas, utom när det är fråga
        om ett akut eller livshotande tillstånd hos djuret eller Djurägaren inte
        kan nås i tid. Betalning sker antingen direkt på kliniken, via Klarna
        eller mot företagsfaktura. Profylaktisk vård och besiktningar ska alltid
        betalas direkt på kliniken eller via Klarna. Om så inte sker lämnar
        Evidensia inte ut intyg. Företagsfakturor ska betalas inom tio (10)
        dagar från fakturadatumet, fakturaavgift tillkommer (summa enligt
        klinikens villkor). Om Djurägaren inte betalar inom den tiden har
        Evidensia rätt att ta ut en påminnelseavgift om sextio (60) kr samt
        ränta på fakturabeloppet med en (1) procent per månad till dess att
        beloppet har betalats. Om Djurägaren inte hämtar sitt djur inom avtalad
        tid efter att den Sjukvårdande behandlingen utförts har Evidensia rätt
        att ta betalt för djurets vistelse enligt gällande
        stationärvårdsavgift/dygnsavgift. Priser ska inkludera mervärdesskatt,
        om inte Evidensia anger något annat. Djurägaren går med på att dennes
        betalningsskyldighet kommer att kvarstå, trots eventuella oförutsedda
        komplikationer eller att någon annan omfattning av den Sjukvårdande
        behandlingen än vad som antecknats i samband med Inskrivningen krävs.
      </Text>

      <Spacer />
      <Text colorTheme sizeLarge>
        REKLAMATION
      </Text>
      <Spacer />
      <Text>
        Inom ett (1) år från det att den Sjukvårdande behandlingen utförts kan
        en Djurägare reklamera den Sjukvårdande behandlingen som har utförts av
        Evidensia. Om Djurägaren anser att den Sjukvårdande behandlingen utförts
        på ett felaktigt sätt och vill reklamera måste detta dock anmälas till
        Evidensia senast en (1) månad efter det att denne upptäckt eller borde
        ha upptäckt felet. Därefter får Djurägaren inte längre reklamera fel i
        den Sjukvårdande behandlingen, även om det inte har gått ett (1) år från
        det att den Sjukvårdande behandlingen utförts. Evidensia ska alltid ges
        möjlighet att korrigera ett fel som upptäcks inom rimlig tid efter att
        en reklamation mottagits. Då görs en veterinärmedicinsk bedömning av den
        Sjukvårdande behandlingen som utförts. Om Evidensia bedömer att man ej
        gjort fel hänvisas till Ansvarsnämnden för djurens hälso- och sjukvård
        (www.vetansvar.se).
      </Text>
      <Spacer />
      <Text colorTheme sizeLarge>
        ANSVARSBEGRÄNSNING
      </Text>
      <Spacer />
      {/* <Text>
        Allmänt: Evidensia ersätter Djurägaren endast för skada som orsakats av
        vårdslöshet eller försummelse vid utförandet av den Sjukvårdande
        behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust,
        skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan
        betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid
        gällande enligt socialförsäkringsbalken), om inte något annat anges i
        dessa Allmänna villkor. Evidensia ersätter inte Djurägaren för skada
        till följd av att Djurägaren använder, eller förlitar sig på, ett
        besiktningsprotokoll för något annat syfte än det syfte som angavs i
        samband med Inskrivningen.
      </Text> */}

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Allmänt</b>: Evidensia ersätter Djurägaren endast för skada som orsakats av
        vårdslöshet eller försummelse vid utförandet av den Sjukvårdande
        behandlingen, dock inte indirekt skada. Evidensia ersätter inte förlust,
        skada eller utebliven vinst i näringsverksamhet. Ersättning enligt ovan
        betalas med ett högsta belopp om ett (1) prisbasbelopp (vid var tid
        gällande enligt socialförsäkringsbalken), om inte något annat anges i
        dessa Allmänna villkor. Evidensia ersätter inte Djurägaren för skada
        till följd av att Djurägaren använder, eller förlitar sig på, ett
        besiktningsprotokoll för något annat syfte än det syfte som angavs i
        samband med Inskrivningen.`}
          id="Uo14SK"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`<b>Profylaktisk behandling på initiativ av Djurägaren</b>: Evidensia ersätter
        inte skada till följd av profylaktisk behandling som utförts på
        initiativ av Djurägaren om Evidensia dessförinnan har avrått Djurägaren
        från behandlingen.`}
          id="bXn7lI"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />
      <Text colorTheme sizeLarge>
        ÄNDRING AV ALLMÄNNA VILLKOR
      </Text>
      <Spacer />
      <Text>
        Evidensia har rätt att när som helst ändra de Allmänna villkoren utan
        att dessförinnan informera Djurägaren. Evidensia ska dock informera
        Djurägaren om väsentliga ändringar och låta Djurägaren få del av de nya
        Allmänna villkoren genom att informera om ändringar på klinikerna och på
        hemsidan www.evidensia.se.
      </Text>
      <Spacer />

      <Text colorTheme sizeLarge>
        DEFINITIONER
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage="”<b>Allmänna villkor</b>” betyder dessa allmänna villkor för veterinärtjänster
        enligt dess senaste lydelse."
          id="+Z5RUs"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{ b: (chunks) => <Text weightBold>{chunks}</Text> }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Djurägaren</b>” betyder en person som är minst 18 år och som äger eller har
        ansvar (som ombud för ägaren) för djuret som den Sjukvårdande
        behandlingen avser.`}
          id="F0qtSP"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Evidensia</b>” betyder ett bolag (i) som direkt eller indirekt
        kontrollerar Evidensia; (ii) som är under samma direkta eller indirekta
        ägande eller kontroll som Evidensia; eller (iii) som direkt eller
        indirekt ägs eller kontrolleras av Evidensia. I det här sammanhanget ska
        ett bolag anses vara kontrollerat av någon annan om det andra bolaget
        äger mer än femtio procent (&gt;50%) av rösterna i ett sådant bolag, kan
        styra bolagets angelägenheter eller kontrollera styrelsens, eller
        motsvarande organs, sammansättning av styrelseledamöter eller
        motsvarande.`}
          id="miQryU"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage="”<b>Evidensia</b>” betyder det Dotterbolag inom Evidensia Djursjukvård AB, org.
        Nr 556880-7217, som utför den Sjukvårdande behandlingen."
          id="dnPxQW"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Inskrivning</b>” betyder det förfarande genom vilket Djurägaren registrerar
        sitt djur hos Evidensia i anslutning till den Sjukvårdande behandlingen.
        ”Kostnadsförslag” betyder en ungefärlig prisuppgift för den Sjukvårdande
        behandlingen som Evidensia lämnar till Djurägaren i samband med
        Inskrivningen.`}
          id="mcaPp/"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>

      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Kostnadstak</b>” betyder uppgift om den högsta kostnaden för den
        Sjukvårdande behandlingen som Evidensia, vid Djurägarens förfrågan,
        lämnar till Djurägaren i samband med Inskrivningen`}
          id="qzFV1H"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>
      <Spacer />

      <Text>
        <FormattedMessage
          defaultMessage={`”<b>Sjukvårdande behandling</b>” betyder varje åtgärd som vidtas för att
          medicinskt förebygga, påvisa, lindra eller bota sjukdom, skada eller
          därmed jämförligt tillstånd hos djur; åtgärder för att utföra
          operativa ingrepp på eller ge injektioner till djur i annat fall;
          inklusive, men inte begränsat till, besiktningar av och utlåtanden om
          djurs status, hälsa eller därmed jämförbart tillstånd.`}
          id="H8W9dk"
          description="Text in GeneralTermsAndConditionsPdf"
          values={{
            b: (chunks) => <Text weightBold>{chunks}</Text>,
          }}
        />
      </Text>
    </View>
  );
};
